export default __webpack_public_path__ + "static/media/campfire.94d8c639.mp3";